<template>
  <div>
    <h2>
      Expediente Digital
    </h2>

    <el-row :gutter="24">
      <el-col :md="6" :sm="24">
        <el-card shadow="never" class="information">
          <div slot="header" class="">
            <el-row :gutter="24">
              <el-col :md="24">
                <img :src="employeeData.image ? this.publicPath + '/employees/' + employeeData.image :
                'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png'" width="100%">
              </el-col>
            </el-row>
            <el-row :gutter="24" :style="{textAlign: 'center'}">
              <el-col :md="24">
                <el-row :gutter="24">
                  <el-col :md="24"><strong class="name-header"><p>{{employeeData.names + ' ' + employeeData.last_names}}
                  </p></strong></el-col>
                </el-row>
                <el-row :gutter="24" class="personalData">
                  <el-col :md="24"><strong>{{employeeData.position}}</strong></el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <el-row :gutter="24">
            <el-col :md="24"><h3><strong>Información de Contacto</strong></h3></el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :md="24"><span class="span-style"><p>Teléfono:</p></span></el-col>
          </el-row>
          <el-row :gutter="24" class="personalData">
            <el-col :md="24"><strong>{{ employeeData.phone }}</strong></el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :md="24"><span class="span-style"><p>Correo:</p></span></el-col>
          </el-row>
          <el-row :gutter="24" class="personalData">
            <el-col :md="24"><strong>{{ employeeData.email }}</strong></el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :md="24"><span class="span-style"><p>Dirección:</p></span></el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :md="24"><strong>{{ employeeData.address }}</strong> </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :md="24">
              <el-button class="center" style="width: 100%; margin-top: 30px" type="danger" @click="generatePDF()" :loading="exporting">DESCARGAR PDF</el-button>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :md="18" :sm="24">
          <el-tabs v-model="activeName">
            <el-tab-pane label="Informacion" name="personalInfo">
              <el-card shadow="never" class="personalInfo">
              <el-col :md="12" :sm="24" style="padding-left: 0px;padding-right: 0px;">
                <el-row :gutter="24" class="personalData">
                  <el-col :md="12"><h3><strong>Información Personal</strong></h3></el-col>
                </el-row>
                  <el-row :gutter="24" class="personalData">
                    <el-col :md="12"><span class="span-style">Cédula:</span></el-col>
                    <el-col :md="12"><strong>{{ employeeData.card }}</strong></el-col>
                  </el-row>
                  <el-row :gutter="24" class="personalData">
                    <el-col :md="12"><span class="span-style">Fecha nacimiento:</span></el-col>
                    <el-col :md="12"><strong>{{ employeeData.birthdate }}</strong></el-col>
                  </el-row>
                  <el-row :gutter="24" class="personalData">
                    <el-col :md="12"><span class="span-style">Nacionalidad:</span></el-col>
                    <el-col :md="12"><strong>{{ employeeData.nationality }}</strong></el-col>
                  </el-row>
                  <el-row :gutter="24" class="personalData">
                    <el-col :md="12"><span class="span-style">Genero:</span></el-col>
                    <el-col :md="12"><strong>{{ employeeData.gender }}</strong></el-col>
                  </el-row>
                  <el-row :gutter="24" class="personalData">
                    <el-col :md="12"><span class="span-style">Estado civil:</span></el-col>
                    <el-col :md="12"><strong>{{ employeeData.civil_status.name }}</strong></el-col>
                  </el-row>
                  <el-row :gutter="24" class="personalData">
                    <el-col :md="12"><span class="span-style">Cantidad de hijos:</span></el-col>
                    <el-col :md="12"><strong>{{ employeeData.child_amount }}</strong></el-col>
                  </el-row>
                  <el-row :gutter="24" class="personalData">
                    <el-col :md="12"><span class="span-style">Codigo empleado:</span></el-col>
                    <el-col :md="12"><strong>{{ employeeData.employee_code }}</strong></el-col>
                  </el-row>
                  </el-col>
                <el-col :md="12" :sm="24" style="padding-left: 0px;padding-right: 0px;">
                  <el-row :gutter="24" class="personalData">
                    <el-col :md="12"><h3><strong>Información de Pago</strong></h3></el-col>
                  </el-row>
                  <el-row :gutter="24" class="personalData">
                    <el-col :md="12"><span class="span-style">Banco:</span></el-col>
                    <el-col :md="12"><strong>{{ employeeData.bank.name }}</strong></el-col>
                  </el-row>
                  <el-row :gutter="24" class="personalData">
                    <el-col :md="12"><span class="span-style">Cuenta Bancaria:</span></el-col>
                    <el-col :md="12"><strong>{{ employeeData.bank_account }}</strong></el-col>
                  </el-row>
                  <el-row :gutter="24" class="personalData">
                    <el-col :md="12"><span class="span-style">Pensión Alimenticia:</span></el-col>
                    <el-col :md="12"><strong>{{ (employeeData.child_amount)? "Si" : "No"  }}</strong></el-col>
                  </el-row>
                  <el-row :gutter="24" class="personalData">
                    <el-col :md="12"><span class="span-style">Monto Pensión:</span></el-col>
                    <el-col :md="12"><strong>{{ employeeData.child_samount }}</strong></el-col>
                  </el-row>

              </el-col>
              </el-card>
            </el-tab-pane>
            <el-tab-pane label="Acciones de personal" name="personalActions">
              <personal-actions :employee_id="$route.params.employee" :read_only="true"></personal-actions>
            </el-tab-pane>
            <el-tab-pane label="Contratos" name="contracts">
              <contract-list :employee_id="$route.params.employee" :read_only="true"></contract-list>
            </el-tab-pane>
            <el-tab-pane label="Vacaciones" name="vacations">
              <vacation-list :employee_id="$route.params.employee" :read_only="true"></vacation-list>
            </el-tab-pane>
            <el-tab-pane label="Incidencias" name="incidents">
              <incident-list :employee_id="$route.params.employee" :read_only="true"></incident-list>
            </el-tab-pane>
          </el-tabs>

      </el-col>
    </el-row>
  </div>

</template>
<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>
<script>
  import {parseError} from '../../packages/Helpers'
  import {baseApi, baseUrl} from '../../configs/urls'
  import PictureInput from 'vue-picture-input'
  import AppTable from '../../components/Table'
  import ContractList from '@/views/employees/ContractList'
  import IncidentList from '@/views/employees/IncidentList'
  import VacationList from '@/views/employees/VacationList'
  import PersonalActions from '@/views/employees/PersonalActions'
  import {saveAs} from 'file-saver'

  export default {
    name: 'employee-list',
    directives: {
    },
    components: {
      PictureInput,
      AppTable,
      VacationList,
      IncidentList,
      ContractList,
      PersonalActions,
      saveAs
    },
    data () {
      return {
        form: {},
        activeName: 'personalInfo',
        civilUrl: baseApi + '/civilstatus/getlist',
        employeeData: null,
        exporting: false,
        publicPath: baseUrl
      }
    },
    methods: {
      getData () {
        this.$http.get(baseApi + '/employees/' + this.$route.params.employee)
          .then(
            (res) => {
              const data = res.body
              if (data.activeContract) {
                data.position = data.activeContract.position.name
              } else {
                data.position = 'Sin Contrato Activo'
              }
              this.employeeData = data
            },
            (res) => {
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
            }
          )
      },
      generatePDF () {
        let url = baseApi + '/employees/' + this.$route.params.employee + '/generatePdf'
        this.exporting = true
        this.$http.post(url, null, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/pdf'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/pdf'})
              let filename = 'expediente_digital'
              saveAs(blob, filename + '.pdf')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      }
    },
    mounted () {
      this.getData()
    }
  }
</script>
<style>
  .float-left{
    float: right;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .span-style{
    color: darkgray;
  }
  .personalData{
    padding-bottom: 20px;
  }
  .information{
    padding: 30px;
  }
  .personalInfo{
    padding: 10px 30px 30px 30px;
  }
  .name-header{
    font-size: 20px;
    color: #409EFF;
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/employees/EmployeeProfile.vue